import { render, staticRenderFns } from "./Abouts.vue?vue&type=template&id=690bb077&scoped=true"
import script from "./Abouts.vue?vue&type=script&lang=js"
export * from "./Abouts.vue?vue&type=script&lang=js"
import style0 from "./Abouts.vue?vue&type=style&index=0&id=690bb077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690bb077",
  null
  
)

export default component.exports